export const FETCH_SEARCH_DETAILS_BEGIN = 'FETCH_SEARCH_DETAILS_BEGIN';
export const FETCH_SEARCH_DETAILS_SUCCESS = 'FETCH_SEARCH_DETAILS_SUCCESS';
export const FETCH_SEARCH_DETAILS_FAILURE = 'FETCH_SEARCH_DETAILS_FAILURE';
export const FILTER_BY_BRAND = 'FILTER_BY_BRAND';
export const RESET_STATE = 'RESET_STATE';
export const FETCH_SEARCH_COUNT_BEGIN = 'FETCH_SEARCH_COUNT_BEGIN';
export const FETCH_SEARCH_COUNT_SUCCESS = 'FETCH_SEARCH_COUNT_SUCCESS';
export const FETCH_SEARCH_COUNT_FAILURE = 'FETCH_SEARCH_COUNT_FAILURE';
export const FETCH_SEARCH_URLS_BEGIN = 'FETCH_SEARCH_URLS_BEGIN';
export const FETCH_SEARCH_URLS_SUCCESS = 'FETCH_SEARCH_URLS_SUCCESS';
export const FETCH_SEARCH_URLS_FAILURE = 'FETCH_SEARCH_URLS_FAILURE';
export const GET_PRODUCT_LIST_SUCCESS = 'GET_PRODUCT_LIST_SUCCESS';
export const GET_PRODUCT_LIST_FAILURE = 'GET_PRODUCT_LIST_FAILURE';
export const GET_PRODUCT_LIST_BEGIN = 'GET_PRODUCT_LIST_BEGIN';